import { useTenancy } from "@/contexts/TenancyContext";
import { useState, useEffect } from "react";
import { db } from "@/js/external-js/config/main_config";
import { toLocalDateString } from "@shared/renderDate";

const FootNote = () => {
    const { activeTenancy } = useTenancy();

    // Get management system guide version and last changed date from db
    const [msgVersion, setMgsVersion] = useState('');
    const [msgLastChanged, setMgsLastChanged] = useState('');
    
    useEffect(() => {
        if (!activeTenancy || !activeTenancy.id || ["", "Loading..."].includes(activeTenancy.id)) return;
        
        const docRef = db.collection('customers')
            .doc(activeTenancy.id)
            .collection('product')
            .doc('managementSystemGuide');
        
        // Set up real-time listener
        const unsubscribe = docRef.onSnapshot(async (docSnap) => {
            try {
                if (docSnap.exists) {
                    const data = docSnap.data();
                    console.log('[FootNote] MSG info updated:', data);
                    
                    // Check if version and lastUpdated exist, if not initialize them
                    if (!data.version || !data.lastUpdated) {
                        const now = new Date();
                        const updates: any = {};
                        
                        if (!data.version) {
                            updates.version = '1.0.0';
                        }
                        if (!data.lastUpdated) {
                            updates.lastUpdated = now;
                        }
                        
                        // Update the document with missing fields
                        await docRef.set(updates, { merge: true });
                        console.log('[FootNote] Initialized missing fields:', updates);
                        
                        // Set state with initialized values
                        setMgsVersion(data.version || '1.0.0');
                        setMgsLastChanged(toLocalDateString(data.lastUpdated?.toDate() || now));
                    } else {
                        setMgsVersion(data.version);
                        setMgsLastChanged(toLocalDateString(data.lastUpdated.toDate()));
                    }
                } else {
                    // Document doesn't exist, create it with initial values
                    const now = new Date();
                    await docRef.set({
                        version: '1.0.0',
                        lastUpdated: now
                    });
                    console.log('[FootNote] Created MSG document with initial values');
                    setMgsVersion('1.0.0');
                    setMgsLastChanged(toLocalDateString(now));
                }
            } catch (error) {
                console.error('[FootNote] Error in snapshot listener:', error);
            }
        }, (error) => {
            console.error('[FootNote] Snapshot listener error:', error);
        });
        
        // Cleanup listener on unmount
        return () => unsubscribe();
    }, [activeTenancy]);
    
    return (
        <div className="foot-note">
          {activeTenancy.legalName || activeTenancy.name}
          <br />
          Management System Guide {msgVersion} - Published: {msgLastChanged}
        </div>
    )
}

export default FootNote;
export { FootNote };
